import {
  type ButtonSize,
  FlatButton,
  stenaCalculate,
} from "@stenajs-webui/elements";
import type { FC } from "react";

import type { CalculatePrice_calculatePrice } from "../../common/pricing/graphql/gql/CalculatePrice";
import type { TrackerCategory } from "../../common/tracking/trackerService";
import type { Placement } from "../popover/FreightPortalPopover";
import { CalculatePriceErrors } from "./CalculatePriceErrors";
import { CalculatePricePopover } from "./CalculatePricePopover";

interface CalculatePriceProps {
  buttonSize?: ButtonSize;
  disabled?: boolean;
  errors: string[];
  loading: boolean;
  onClick: () => void;
  placement?: Placement;
  priceOutdated: boolean;
  result: CalculatePrice_calculatePrice | null;
  trackerCategory: TrackerCategory;
}

export const CalculatePrice: FC<CalculatePriceProps> = ({
  loading,
  errors,
  onClick,
  placement,
  priceOutdated,
  result,
  trackerCategory,
  disabled = false,
  buttonSize,
}) => {
  if (!priceOutdated) {
    if (errors.length > 0) {
      return (
        <CalculatePriceErrors
          errors={errors}
          trackerCategory={trackerCategory}
          placement={placement}
          buttonSize={buttonSize}
        />
      );
    }

    if (result?.articlesResults && result.amountInRouteCurrency) {
      return (
        <CalculatePricePopover
          placement={placement}
          buttonSize={buttonSize}
          amountInRouteCurrency={result.amountInRouteCurrency}
          articlesResults={result.articlesResults}
          trackerCategory={trackerCategory}
        />
      );
    }
  }

  return (
    <FlatButton
      size={buttonSize}
      leftIcon={stenaCalculate}
      label={"Calculate price"}
      loadingLabel={"Calculating..."}
      loading={loading}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
